module.exports = __webpack_public_path__ + "static/media/gmail.23a7dee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/socialMedia/gmail.svg
// module id = 213
// module chunks = 1